import FileUploadArea from './FileUploadArea'

export default FileUploadArea
